import React, {useContext} from 'react';
import { translate } from 'react-multi-lang';
import { Table, Input, Button, Space, Row, Col, Tooltip, Popconfirm, Tabs, Modal, DatePicker } from 'antd';
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { AllHtmlEntities } from 'html-entities';

import Moment from 'react-moment';
import moment from 'moment';
import locale_ca from 'antd/es/date-picker/locale/ca_ES';

import ContainerPagina from '../../../components/ContainerPagina';
import TitolPagina from '../../../components/TitolPagina';
import TriaCursEscolar from '../../../components/TriaCursEscolar';
import LlistaEditableModalNouEditComandes from '../../../components/LlistaEditableModalNouEditComandes';
import Edit from '../../../components/Formularis/perfils/admin/ComandesAcollidaEdit';
import AddMensual from '../../../components/Formularis/perfils/admin/ComandesAcollidaAddMensual';
import AddPuntual from '../../../components/Formularis/perfils/admin/ComandesAcollidaAddPuntual';
import ComandesAcollidaMinutEdit from '../../../components/Formularis/perfils/admin/ComandesAcollidaMinutEdit';
import { Api, InitDades } from '../../../helpers';
import {PerfilUsuariContext} from "../../../context/perfil-usuari";

const { Column } = Table;
const entities = new AllHtmlEntities();
moment.locale('es');
const dateRangeFormat = 'DD/MM/YYYY';

function ComandesAcollida(props){
  const [ perfilUsuari ] = useContext(PerfilUsuariContext);
  return (<ComandesAcollidaClass t={props.t} id_curs_escolar={perfilUsuari.curs_escolar_actual.id}/>);
}


class ComandesAcollidaClass extends React.Component{
  static contextType = PerfilUsuariContext;

  constructor(props){
    super(props);
    console.log('Props del constructor',props)
    var date = new Date();
    this.state = {
      filtresClasses: [],
      searchText: '',
      searchedColumn: '',
      modalVisible: false,
      modalMinutsVisible: false,
      tipus: 'anual',
      esPuntual: false,
      refrescar_anual: 0,
      refrescar_puntual: 0,
      refrescar_minuts: 0,
      cursEscolarTriat: props.id_curs_escolar,
      fini: moment().clone().startOf('month'),      
      ffin: moment().clone().endOf('month'),
    };
  }

  async componentDidMount(){
    this.creaFiltreClasses(this.state.cursEscolarTriat);
  }



  creaFiltreClasses = async (curs) => {
    const cla = await Api.get(`/classes/all/${curs}`);
    if(cla.result.success!==1){return [];}

    const filtreCl = cla.data.classes.map((item)=>{
      return {text: item.nom, value: item.id}
    });
    this.setState({filtresClasses: filtreCl});
  }

  buscarDades_anual = async () => {
    const c = await Api.get(`/acollida/comandes/all/${this.state.cursEscolarTriat}/mensual`);
    if(c.result.success===1){
      const com = c.data.comandes.map((item)=>{
        item.alumne_nom_t = entities.decode(item.alumne_nom);
        item.pare_nom_t = entities.decode(item.pare_nom);
        item.acollida_t = entities.decode(item.acollida[this.props.t('idioma')]);
        item.propietat_t = entities.decode(item.propietat[this.props.t('idioma')]);
        return item;
      });
      return com;
    }
  }
  buscarDades_puntual = async () => {
    const c = await Api.get(`/acollida/comandes/all/${this.state.cursEscolarTriat}/puntual`);
    if(c.result.success===1){
      const com = c.data.comandes.map((item)=>{
        item.alumne_nom_t = entities.decode(item.alumne_nom);
        item.pare_nom_t = entities.decode(item.pare_nom);
        item.acollida_t = entities.decode(item.acollida[this.props.t('idioma')]);
        item.propietat_t = entities.decode(item.propietat[this.props.t('idioma')]);
        return item;
      });
      return com;
    }
  }

  buscarDades_minuts = async () => {
    const c = await Api.get(`/acollidaminuts/comandes/all/${this.state.cursEscolarTriat}`);
    if(c.result.success===1){
      const com = c.data.comandes.map((item)=>{
        item.alumne_nom_t = entities.decode(item.alumne_nom);
        item.pare_nom_t = entities.decode(item.pare_nom);
        item.tipus_t = this.props.t(`acollida.${item.tipus}`)
        return item;
      });
      return com;
    }
  }

  buscarDades_minuts_per_dates = async () => {
    const data_inicial = this.state.fini ? this.state.fini.clone().format('YYYY-MM-DD') : null;
    const data_final = this.state.ffin ? this.state.ffin.clone().add(1, 'days').format('YYYY-MM-DD') : null;
    console.log('buscar per dates', `/acollidaminuts/comandes/dates/${this.state.cursEscolarTriat}/${data_inicial}/${data_final}`)
    const c = await Api.get(`/acollidaminuts/comandes/dates/${this.state.cursEscolarTriat}/${data_inicial}/${data_final}`);
    if(c.result.success===1){
      const com = c.data.comandes.map((item)=>{
        item.alumne_nom_t = entities.decode(item.alumne_nom);
        item.pare_nom_t = entities.decode(item.pare_nom);
        item.tipus_t = this.props.t(`acollida.${item.tipus}`)
        return item;
      });
      return com;
    }
  }


  eliminar = async (id) => {
    const del = await Api.myFetch(`/acollida/comanda/${id}`, 'DELETE');
    if(del.result.success===1){

    }
  }
  eliminarMinuts = async (id) => {
    const del = await Api.myFetch(`/acollidaminuts/comanda/${id}`, 'DELETE');
    if(del.result.success===1){

    }
  }

  triaCursChange = (curs) => {
    this.creaFiltreClasses(curs);
    const refrescarPuntual = this.state.refrescar_puntual+1;
    const refrescarAnual = this.state.refrescar_anual+1;
    const refrescarMinuts = this.state.refrescar_minuts+1;
    this.setState({ cursEscolarTriat: curs,
                    refrescar_puntual: refrescarPuntual,
                    refrescar_anual: refrescarAnual,
                    refrescar_minuts: refrescarMinuts});
  }

  getColumnSearchProps = (dataIndex, nom) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`${this.props.t('generic.cercar')} ${nom}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            {this.props.t('generic.cercar')}
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      //record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
      record[dataIndex] ? this.arreglarTxt4Search(entities.decode(record[dataIndex].toString())).includes(this.arreglarTxt4Search(value)) : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text => (entities.decode(text)),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  arreglarTxt4Search = text =>{
      // Poso en minuscules, normalitzo caracters treure accents i ñ , elimina els caracters diacrítics raros d'un text (ES6)
        return text.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
  }

  triaTab = (key) =>{
    let esPuntual = false;
    //setRefrescar(refrescar+1);
    if(key==='puntual'){
      esPuntual = true;
    }
    this.setState({ tipus: key, esPuntual });
  }
  tancarModal_anual = e =>{
    //setRefrescar(refrescar+1);
    const refrescar = this.state.refrescar_anual+1;
    this.setState({ modalVisible: false, refrescar_anual: refrescar });
  }
  tancarModal_puntual = e =>{
    //setRefrescar(refrescar+1);
    const refrescar = this.state.refrescar_puntual+1;
    this.setState({ modalVisible: false, refrescar_puntual: refrescar });
  }
  tancarModal_minuts = e =>{
    //setRefrescar(refrescar+1);
    const refrescar = this.state.refrescar_minuts+1;
    this.setState({ modalMinutsVisible: false, refrescar_minuts: refrescar });
  }
  showModal = e =>{
    //setRefrescar(refrescar+1);
    this.setState({ modalVisible: true });
  }
  showModalMinuts = e =>{
    //setRefrescar(refrescar+1);
    this.setState({ modalMinutsVisible: true });
  }

  onDateRangeChange = (dates, dateStrings) => {

    this.setState({fini: dates ? dates[0] : ''});
    this.setState({ffin: dates ? dates[1] : ''});
    const refrescar = this.state.refrescar_minuts+1;
    this.setState({ refrescar_minuts: refrescar });

  }

render(){


const { filtresClasses, modalVisible, modalMinutsVisible, tipus, esPuntual, refrescar_anual, refrescar_puntual, refrescar_minuts, cursEscolarTriat, fini, ffin } = this.state;
const btnAfegir =
  <Space>
    <TriaCursEscolar defaultValue={cursEscolarTriat} onChange={(c) => this.triaCursChange(c)}/>
    <Button type="primary" onClick={this.showModal}>
    {
      esPuntual
      ? this.props.t('generic.add')+ ' '+ this.props.t('generic.puntual')
      : this.props.t('generic.add')+ ' '+ this.props.t('generic.anual')
    }
    </Button>
  </Space>;

const columns_anual = [
{
  title:"Id",
  key:"id",
  sorter: (a, b) =>  a.id - b.id,
  render: (text,record) => (<span>{record.id}</span>)
},{
  title: this.props.t('alumnes.classe'),
  key:"classe",
  dataIndex: 'classe',
  filters: filtresClasses,
  onFilter: (value, record) => record.id_classe === value,
  render: (text,record) =>(entities.decode(record.classe)),
  sorter: (a, b) => { return entities.decode(a.classe).localeCompare(entities.decode(b.classe))},
},{
  title: this.props.t('alumnes.nom'),
  key:"alumne_nom_t",
  dataIndex: 'alumne_nom_t',
  sorter: (a, b) => { return a.alumne_nom_t.localeCompare(b.alumne_nom_t)},
  ...this.getColumnSearchProps('alumne_nom_t',this.props.t('alumnes.nom'))
},{
  title:this.props.t('menu.Acollida'),
  key:"acollida_t",
  dataIndex: 'acollida_t',
  sorter: (a, b) => { return a.acollida_t.localeCompare(b.acollida_t)},
  ...this.getColumnSearchProps('acollida_t',this.props.t('menu.Acollida'))
},{
  title:this.props.t('acollida.titol'),
  key:"propietat_t",
  dataIndex: 'propietat_t',
  sorter: (a, b) => { return a.propietat_t.localeCompare(b.propietat_t)},
  ...this.getColumnSearchProps('propietat_t',this.props.t('acollida.titol'))
},{
  title:this.props.t('generic.total'),
  key:"total",
  sorter: (a, b) =>  a.total - b.total,
  render:(text,record) => (<span>{record.total}€</span>)
},{
  title:this.props.t('generic.created_at'),
  key:"creat",
  sorter: (a, b) => moment(a.creat).diff(moment(b.creat)),
  responsive:['md'],
  render:(text,record) => (record.creat ? <Moment date={moment(record.creat)} format="DD/MM/YYYY HH:mm"/> : "" )
}];

const columns_puntual = [
{
  title:"Id",
  key:"id",
  sorter: (a, b) =>  a.id - b.id,
  render: (text,record) => (<span>{record.id}</span>)
},{
  title: this.props.t('alumnes.classe'),
  key:"classe",
  dataIndex: 'classe',
  filters: filtresClasses,
  onFilter: (value, record) => record.id_classe === value,
  render: (text,record) =>(entities.decode(record.classe)),
  sorter: (a, b) => { return entities.decode(a.classe).localeCompare(entities.decode(b.classe))},
},{
  title: this.props.t('alumnes.nom'),
  key:"alumne_nom_t",
  dataIndex: 'alumne_nom_t',
  sorter: (a, b) => { return a.alumne_nom_t.localeCompare(b.alumne_nom_t)},
  ...this.getColumnSearchProps('alumne_nom_t',this.props.t('alumnes.nom'))
},{
  title:this.props.t('menu.Acollida'),
  key:"acollida_t",
  dataIndex: 'acollida_t',
  sorter: (a, b) => { return a.acollida_t.localeCompare(b.acollida_t)},
  ...this.getColumnSearchProps('acollida_t',this.props.t('menu.Acollida'))
},{
  title:this.props.t('acollida.titol'),
  key:"propietat_t",
  dataIndex: 'propietat_t',
  sorter: (a, b) => { return a.propietat_t.localeCompare(b.propietat_t)},
  ...this.getColumnSearchProps('propietat_t',this.props.t('acollida.titol'))
},{
  title:this.props.t('generic.total'),
  key:"total",
  sorter: (a, b) =>  a.total - b.total,
  render:(text,record) => (<span>{record.total}€</span>)
},{
  title:this.props.t('generic.data'),
  key:"puntual_data",
  sorter: (a, b) => moment(a.puntual_data).diff(moment(b.puntual_data)),
  responsive:['md'],
  render:(text,record) => (record.puntual_data ? <Moment date={new Date(record.puntual_data)} format="DD/MM/YYYY"/> : "" )
}];

const columns_minuts = [
{
  title:"Id",
  key:"id",
  sorter: (a, b) =>  a.id - b.id,
  render: (text,record) => (<span>{record.id}</span>)
},{
  title: this.props.t('acollida.tipus'),
  key:"tipus",
  dataIndex: 'tipus',
  filters: [{text: this.props.t('acollida.mati'), value: 'mati'},{text: this.props.t('acollida.tarda'), value: 'tarda'}],
  onFilter: (value, record) => record.tipus === value,
  render: (text,record) =>(this.props.t(`acollida.${record.tipus}`)),
  sorter: (a, b) => { return entities.decode(this.props.t(`acollida.${a.tipus}`)).localeCompare(entities.decode(this.props.t(`acollida.${b.tipus}`)))},
},{
  title: this.props.t('alumnes.classe'),
  key:"classe",
  dataIndex: 'classe',
  filters: filtresClasses,
  onFilter: (value, record) => record.id_classe === value,
  render: (text,record) =>(entities.decode(record.classe)),
  sorter: (a, b) => { return entities.decode(a.classe).localeCompare(entities.decode(b.classe))},
},{
  title: this.props.t('alumnes.nom'),
  key:"alumne_nom_t",
  dataIndex: 'alumne_nom_t',
  sorter: (a, b) => { return a.alumne_nom_t.localeCompare(b.alumne_nom_t)},
  ...this.getColumnSearchProps('alumne_nom_t',this.props.t('alumnes.nom'))
},{
  title: this.props.t('generic.hini'),
  key:"h_ini",
  sorter: (a, b) =>  a.minuts_facturar - b.minuts_facturar,
  render:(text,record) => (<span>{String(record.h_ini).padStart(2, '0')}:{String(record.m_ini).padStart(2, '0')}</span>)
},{
  title: this.props.t('generic.hfin'),
  key:"h_fin",
  sorter: (a, b) =>  a.minuts_facturar - b.minuts_facturar,
  render:(text,record) => (<span>{String(record.h_fin).padStart(2, '0')}:{String(record.m_fin).padStart(2, '0')}</span>)
},{
  title: this.props.t('acollida.minuts'),
  key:"minuts_facturar",
  sorter: (a, b) =>  a.minuts_facturar - b.minuts_facturar,
  render:(text,record) => (<span>{record.minuts_facturar}</span>)
},{
  title: this.props.t('generic.preu'),
  key:"preu",
  sorter: (a, b) =>  a.preu - b.preu,
  render:(text,record) => (<span>{record.preu}€</span>)
},{
  title: this.props.t('generic.descompte'),
  key:"descompte",
  sorter: (a, b) =>  a.descompte - b.descompte,
  render:(text,record) => (<span>{record.descompte}%</span>)
},{
  title: this.props.t('generic.total'),
  key:"total",
  sorter: (a, b) =>  a.total - b.total,
  render:(text,record) => (<span>{record.total}€</span>)
},{
  title: this.props.t('generic.data'),
  key:"puntual_data",
  sorter: (a, b) => moment(a.puntual_data).diff(moment(b.puntual_data)),
  responsive:['md'],
  render:(text,record) => (record.puntual_data ? <Moment date={new Date(record.puntual_data)} format="DD/MM/YYYY"/> : "" )
}];

  return(
    <ContainerPagina xl={24}>
      <TitolPagina txt={this.props.t('menu.Comandes')+' '+this.props.t('menu.Acollida')}/>
      <div style={{marginTop:'1rem', marginLeft:'3rem'}}>


  { cursEscolarTriat === 1
    ?
      <Tabs defaultActiveKey="anual" tabBarExtraContent={btnAfegir} onChange={this.triaTab}>
        <Tabs.TabPane tab={this.props.t('generic.anual')} key="anual">
          <LlistaEditableModalNouEditComandes
            scroll={{ x: 1500}}
            txt_creats={this.props.t('menu.Comandes')}
            txt_nou={this.props.t('generic.add')}
            buscarDades={this.buscarDades_anual}
            edit={Edit}
            id_curs_escolar={cursEscolarTriat}
            add={null}
            delete={this.eliminar}
            itemBuit={InitDades.comandesExtraescolars()}
            columns={columns_anual}
            refrescar={refrescar_anual}
            />
        </Tabs.TabPane>
        <Tabs.TabPane tab={this.props.t('generic.puntual')} key="puntual">
          <LlistaEditableModalNouEditComandes
            scroll={{ x: 1500}}
            txt_creats={this.props.t('menu.Comandes')}
            txt_nou={this.props.t('generic.add')}
            buscarDades={this.buscarDades_puntual}
            edit={Edit}
            id_curs_escolar={cursEscolarTriat}
            add={null}
            delete={this.eliminar}
            itemBuit={InitDades.comandesExtraescolars()}
            columns={columns_puntual}
            refrescar={refrescar_puntual}
            />
        </Tabs.TabPane>
      </Tabs>
    :
    <>
    <Row align="middle" justify="space-between" gutter={5} style={{marginBottom: '1rem'}}>
      <Col>
        <Space>
          <span><b>{this.props.t('generic.filtre')}:&nbsp;</b></span>
          <DatePicker.RangePicker
            value={[fini ? moment(fini, dateRangeFormat) : null, ffin ? moment(ffin, dateRangeFormat) : null]}
            format={dateRangeFormat}
            locale={locale_ca}
            onChange={this.onDateRangeChange}
            size="large"
          />

          {/*<Button type="primary" onClick={mesActualFiltre}>{props.t('generic.mes_actual')}</Button>
          <Button type="primary" onClick={mesAnteriorfiltre}>{props.t('generic.mes_anterior')}</Button>
          <Button type="primary" onClick={avuiFiltre}>{props.t('generic.avui')}</Button>
          <Button type="primary" onClick={netejarFiltres}>{props.t('generic.tot')}</Button>*/}

        </Space>
      </Col>
    </Row>

      <LlistaEditableModalNouEditComandes
        scroll={{ x: 1500}}
        btn_extra={
          <Space>
            <TriaCursEscolar defaultValue={cursEscolarTriat} onChange={(c) => this.triaCursChange(c)}/>
            <Button type="primary" onClick={this.showModalMinuts}>{this.props.t('generic.add')}</Button>
            </Space>}
        txt_creats={this.props.t('menu.Comandes')}
        txt_nou={this.props.t('generic.add')}
        //buscarDades={this.buscarDades_minuts}
        buscarDades={this.buscarDades_minuts_per_dates}
        edit={ComandesAcollidaMinutEdit}
        duplica={true}
        id_curs_escolar={cursEscolarTriat}
        add={null}
        delete={this.eliminarMinuts}
        itemBuit={InitDades.acollidaMinutsComanda()}
        columns={columns_minuts}
        refrescar={refrescar_minuts}
        />
        </>

    }
      </div>
      <Modal
          key="afegirComanda"
          title={
            esPuntual
            ? this.props.t('generic.add')+ ' '+ this.props.t('generic.puntual')
            : this.props.t('generic.add')+ ' '+ this.props.t('generic.anual')
          }
          visible={modalVisible}
          footer={null}
          onCancel={(e) => this.setState({modalVisible: false})}
          width={600}
          style={{top:10}}
          bodyStyle={{ overflow: "auto"}}
          destroyOnClose={true}
          forceRender={true}
          maskClosable={true}
          closable={true}
        >
        {esPuntual
          ? <AddPuntual id_curs_escolar={cursEscolarTriat} puntual={esPuntual} tancarModal={this.tancarModal_puntual}/>
          : <AddMensual id_curs_escolar={cursEscolarTriat} puntual={esPuntual} tancarModal={this.tancarModal_anual}/>
        }
      </Modal>
      <Modal
          key="afegirComandaMinuts"
          title={this.props.t('generic.add')}
          visible={modalMinutsVisible}
          footer={null}
          onCancel={(e) => this.setState({modalMinutsVisible: false})}
          width={600}
          style={{top:10}}
          bodyStyle={{ overflow: "auto"}}
          destroyOnClose={true}
          forceRender={true}
          maskClosable={true}
          closable={true}
        >
          <ComandesAcollidaMinutEdit item={InitDades.acollidaMinutsComanda()} id_curs_escolar={cursEscolarTriat} tancarModal={this.tancarModal_minuts}/>
      </Modal>

    </ContainerPagina>
  );
}
}

export default translate(ComandesAcollida);
